export const SiteLanguage = {
    Static: 'static',
    NodeJS: 'nodejs',
    PHP: 'php',
};
